module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if(is_show_trade_notice){ 
__p+='\n  <div class="trade-info-box trade-errors-box">\n    <i class="ion-android-warning"></i>\n    <b>Trade Info</b>\n    <span>Making more than two trades is a two step process.</span>\n  </div>\n';
 } 
__p+='\n\n';
 function player(player, index, reverse, is_confirmed){ 
__p+='\n	<div class="player-cell"\n	     data-player-id="'+
((__t=( player.id ))==null?'':_.escape(__t))+
'"\n	     data-side-key="'+
((__t=( reverse ? 'in' : 'out' ))==null?'':_.escape(__t))+
'"\n	     data-trade-index="'+
((__t=( index ))==null?'':_.escape(__t))+
'">\n		';
 if(!reverse){ 
__p+='\n			<figure>\n				<picture>\n					<source	srcset="'+
((__t=( _.getPlayerAvatarUrl({ id: player.id, size: 100, format:'webp' }) ))==null?'':_.escape(__t))+
'" type="image/webp" />\n					<img src="'+
((__t=( _.getPlayerAvatarUrl({ id: player.id, size: 100 }) ))==null?'':_.escape(__t))+
'"\n					     alt="'+
((__t=( player.first_name + ' ' + player.last_name ))==null?'':_.escape(__t))+
'">\n				</picture>\n				';
 if(!is_confirmed){ 
__p+='\n					<button class="btn-delete-player js-btn-delete-player">\n						<i class="icon ion-close-round"></i>\n					</button>\n				';
 } 
__p+='\n			</figure>\n		';
 } 
__p+='\n		<div class="player-info">\n			<div class="player-name">\n				<i class="icon player-status '+
((__t=( player.status ))==null?'':_.escape(__t))+
'"></i>\n				<span>'+
((__t=( player.first_name[0] ))==null?'':_.escape(__t))+
'. '+
((__t=( player.last_name ))==null?'':_.escape(__t))+
'</span>\n				';
 if(player.leader_class_name){ 
__p+='\n					<i class="icon player-status player-lead-status '+
((__t=( player.leader_class_name ))==null?'':_.escape(__t))+
'"></i>\n				';
 } 
__p+='\n			</div>\n			<div class="player-stats">\n				<span class="player-opponent">\n					<b>'+
((__t=( player.squad.short_name ))==null?'':_.escape(__t))+
'</b> '+
((__t=( player.opponents.symbol ))==null?'':_.escape(__t))+
' '+
((__t=( player.opponent.short_name ))==null?'':_.escape(__t))+
'\n				</span>\n				<span> | </span>\n				<span class="player-positions">\n					'+
((__t=( player.position_names.join(', ') ))==null?'':_.escape(__t))+
'\n				</span>\n				<br>\n				<span class="player-cost">\n					'+
((__t=( _.currencyFormat(player.cost) ))==null?'':_.escape(__t))+
'\n				</span>\n				<span>&nbsp;|&nbsp;</span>\n				<span class="'+
((__t=( player.cost_season_diff > 0 ? 'positive' : '' || player.cost_season_diff < 0 ? 'negative' : '' ))==null?'':_.escape(__t))+
'">\n					'+
((__t=( _.currencyFormat(player.cost_season_diff, '$', true) ))==null?'':_.escape(__t))+
'\n				</span>\n				<span> </span>\n				(\n				<span class="'+
((__t=( player.cost_round_diff > 0 ? 'positive' : '' || player.cost_round_diff < 0 ? 'negative' : '' ))==null?'':_.escape(__t))+
'">\n					'+
((__t=( _.currencyFormat(player.cost_round_diff, '$', true) ))==null?'':_.escape(__t))+
'\n				</span>\n				)\n			</div>\n		</div>\n		';
 if(reverse){ 
__p+='\n			<figure>\n				<picture>\n					<source	srcset="'+
((__t=( _.getPlayerAvatarUrl({ id: player.id, size: 100, format:'webp' }) ))==null?'':_.escape(__t))+
'" type="image/webp" />\n					<img src="'+
((__t=( _.getPlayerAvatarUrl({ id: player.id, size: 100 }) ))==null?'':_.escape(__t))+
'"\n					     alt="'+
((__t=( player.first_name + ' ' + player.last_name ))==null?'':_.escape(__t))+
'">\n				</picture>\n				';
 if(!is_confirmed){ 
__p+='\n					<button class="btn-delete-player js-btn-delete-player">\n						<i class="icon ion-close-round"></i>\n					</button>\n				';
 } 
__p+='\n			</figure>\n		';
 } 
__p+='\n	</div>\n';
 } 
__p+='\n\n';
 _.each(trades, function(trade, index){ 
__p+='\n	<div class="trade-item">\n		<h4>Trade '+
((__t=( index + 1 ))==null?'':_.escape(__t))+
'</h4>\n		<div class="trade-item-container">\n			<div class="trade-item-player trade-item-out-player">\n				';
 if(!trade.out){ 
__p+='\n					<i class="ion-plus"></i>\n					<span class="trade-item-player-text">Select a player to trade out</span>\n				';
 } else { player(trade.out, index, false, trade.is_confirmed) } 
__p+='\n			</div>\n			<div class="trade-item-middle-icon">\n				';
 if(!trade.is_confirmed){ 
__p+='\n					<img src="/assets/images/trade-icon.png" alt="">\n				';
 } else { 
__p+='\n					<div class="confirmed-trade-icon">\n						<i class="icon ion-checkmark-round"></i>\n					</div>\n				';
 } 
__p+='\n			</div>\n			<div class="trade-item-player trade-item-in-player '+
((__t=( trade.in ? '' : 'js-filter-by-position pointer' ))==null?'':_.escape(__t))+
'"\n				 data-position="'+
((__t=( _.get(trade, 'out.player_position', false) ))==null?'':_.escape(__t))+
'"\n			>\n				';
 if(!trade.in){ 
__p+='\n					<span class="trade-item-player-text ">\n						Select a player to trade in\n					</span>\n					<i class="ion-plus"></i>\n				';
 } else { player(trade.in, index, true, trade.is_confirmed) } 
__p+='\n			</div>\n		</div>\n	</div>\n';
 }) 
__p+='\n\n';
 _.each(locked_trades, function(trade) { 
__p+='\n	<div class="trade-item locked">\n		<h4>Trade '+
((__t=( trade + 1 + trades.length ))==null?'':_.escape(__t))+
'</h4>\n		<div class="trade-item-container">\n			<div class="trade-item-player trade-item-out-player">\n				<i class="ion-plus"></i>\n				<span class="trade-item-player-text">Select a player to trade out</span>\n			</div>\n			<div class="trade-item-middle-icon">\n				<img src="/assets/images/trade-icon.png" alt="">\n			</div>\n			<div class="trade-item-player trade-item-in-player">\n				<span class="trade-item-player-text ">\n						Select a player to trade in\n					</span>\n				<i class="ion-plus"></i>\n			</div>\n		</div>\n	</div>\n';
 }) 
__p+='\n\n';
 if(is_invalid_trade){ 
__p+='\n	<div class="trade-info-box trade-errors-box">\n		<i class="ion-android-warning"></i>\n		<b>Invalid Trade</b>\n		<span>'+
((__t=( trade_error ))==null?'':_.escape(__t))+
'</span>\n	</div>\n';
 } 
__p+='\n\n';
 if(is_valid_trade){ 
__p+='\n	<div class="trade-info-box trade-success-box">\n		<b>Valid Trade</b>\n		<span>Confirm or make another trade</span>\n	</div>\n';
 } 
__p+='\n\n<div class="trade-controls">\n	<button class="btn-reverse-trade js-reverse-trade"\n		'+
((__t=( is_locked_action_reverse ? 'disabled' : '' ))==null?'':_.escape(__t))+
'\n		>REVERSE TRADE</button>\n\n	<button class="btn-confirm-trade js-confirm-trade"\n		'+
((__t=( is_locked_action_trade ? 'disabled' : '' ))==null?'':_.escape(__t))+
'\n		>Confirm Trade</button>\n</div>';
}
return __p;
};
